import Vue from 'vue'
import Router from 'vue-router'
import login from '@/view/login.vue'
import register from '@/view/register.vue'
import layout from '@/view/LayOut/layout.vue'
import home from '@/view/Home/home.vue'
import pm from '@/view/PM/pm.vue'
import notice from '@/view/PM/notice.vue'
import participant from '@/view/PM/participant.vue'
import finished from '@/view/PM/finished.vue'
import my from '@/view/MY/my.vue'
import edit from '@/view/MY/edit.vue'

const Supplier = () => import('../view/Supplier/index.vue')
const SupplierProfile = () => import('../view/Supplier/SupplierProfile/index.vue')
const Productfile = () => import('../view/Supplier/Productfile/index.vue')
const EliminatedSuppliers = () => import('../view/Supplier/EliminatedSuppliers/index.vue')

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'login',
      component: login
    },
    {
      path: '',
      name: 'layout',
      component: layout,
      children: [
        {
          path: '/home',
          name: 'home',
          component: home,
        },
        {
          path: '/pm',
          name: 'pm',
          component: pm,
        },
        {
          path: '/notice',
          name: 'notice',
          component: notice,
        },
        {
          path: '/finished',
          name: 'finished',
          component: finished,
        },
        {
          path: '/participant',
          name: 'participant',
          component: participant,
        },
        {
          path: '/my',
          name: 'my',
          component: my,
        },
        {
          path: '/edit',
          name: 'edit',
          component: edit,
        }


      ]
    },
    {
      path: '/register',
      name: 'register',
      component: register
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js